import React, { useState, useEffect, useRef } from "react";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";
import axiosInstance from "../networking/axiosconfig";
import { ChevronDownIcon } from '@heroicons/react/20/solid'


const EmployeeReportDownload = ({ employeeFilter, dateFilter ,selectedMonth}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);


  const handleDownloadPDF = async () => {
  
    let startDate, endDate;
  
    if (dateFilter?.startDate && dateFilter?.endDate) {
      startDate = new Date(dateFilter.startDate).toISOString().split("T")[0];
      endDate = new Date(dateFilter.endDate).toISOString().split("T")[0];
    } 
     else {
      console.error("Missing required date data:", { dateFilter });
      return;
    }
  
    if (!employeeFilter?.length) {
      console.error("Missing required employee data");
      return;
    }
  
    const employeeId = employeeFilter[0];
  
    const url = `/api/downloadAttendancePdf/${employeeId}`;
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ start_date: startDate, end_date: endDate }),
      });
  
      const responseData = await response.json();
  
      if (response.ok && responseData.status && responseData.attendancePDF) {
        const pdfUrl = responseData.attendancePDF;
        window.open(pdfUrl, "_blank");
      } else {
        console.error("Failed to fetch PDF:", responseData.message);
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  
    setIsOpen(false);
  };
  

  // Function to handle Excel download (You can follow similar steps as PDF)
  const handleDownloadExcel = async () => {
    if (!employeeFilter.length || !dateFilter.startDate || !dateFilter.endDate) {
      console.error("Missing required filter data");
      return;
    }

    const startDate = new Date(dateFilter.startDate).toISOString().split("T")[0];
    const endDate = new Date(dateFilter.endDate).toISOString().split("T")[0];
    const employeeId = employeeFilter[0];  // Assuming only one employee is selected

    // Construct the API URL for the Excel download
    const url = `/api/downloadAttendancePdf/attendance-excelsheet/${employeeId}`;

    // Set up the data for the request
    const data = {
      start_date: startDate,
      end_date: endDate,
    };

    const url1 = `/api/downloadAttendancePdf/attendance-excelsheet/${employeeId}`;
  
    try {
      const response = await fetch(url1, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ start_date: startDate, end_date: endDate }),
      });
  
      const responseData = await response.json();
  
      if (response.ok && responseData.status && responseData.attendanceExcel) {
        const pdfUrl = responseData.attendanceExcel;
        window.open(pdfUrl, "_blank");
      } else {
        console.error("Failed to fetch Excel:", responseData.message);
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



  return (
    <div className="relative" ref={dropdownRef}>
      {/* <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex w-full justify-center gap-x-1.5 font-inter rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
      >
        Download Report
        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5  text-gray-400" />

      </button> */}

      {isOpen && (
        <div className="absolute right-0 mt-2 w-40 bg-white border rounded-md shadow-lg z-10">
          <button
            onClick={handleDownloadPDF}
            className="flex items-center gap-2 px-4 py-2 w-full text-left hover:bg-gray-100"
          >
            <FaFilePdf className="text-red-600" /> PDF
          </button>

          <button
            onClick={handleDownloadExcel}
            className="flex items-center gap-2 px-4 py-2 w-full text-left hover:bg-gray-100"
          >
            <FaFileExcel className="text-green-600" /> Excel
          </button>
        </div>
      )}
    </div>
  );
};

export default EmployeeReportDownload;



